
import { defineComponent, ref } from 'vue'

const TABS = [
    { id: 'same', label: 'ОПЗ 2.0' },
    { id: 'cross', label: 'Кросс-продажи' },
    { id: 'kpi', label: 'KPI' },
] as const

export default defineComponent({
    name: 'Opz2ReportPreview',
    setup() {
        const activeTab = ref<(typeof TABS)[number]['id']>('same')

        return {
            tabs: TABS,
            activeTab,
        }
    },
})
